import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'data', 'expandBtn', 'collapseBtn' ];
  static classes = [ 'collapsed', 'hidden' ];

  expand() {
    this.expandBtnTarget.classList.add(this.hiddenClass);
    this.collapseBtnTarget.classList.remove(this.hiddenClass);
    const dataHeight = this.dataTarget.scrollHeight + "px";
    this.dataTarget.style.maxHeight = dataHeight;
    this.dataTarget.classList.remove(this.collapsedClass);
    this.element.style.zIndex = '1';
  }

  collapse() {
    this.collapseBtnTarget.classList.add(this.hiddenClass);
    this.expandBtnTarget.classList.remove(this.hiddenClass);
    this.dataTarget.classList.add(this.collapsedClass);
    this.element.style.zIndex = '0';
  }
}
